import React, { useEffect, useState } from "react";
import "./footer.scss";
import {
  ApplicationLink,
  ApplicationLinkResult,
} from "../../interfaces/applicationlink";
import linkServices from "../../services/applicationlinkservice";
import { LINKNAME, LINKSECTION } from "../../const/linksection";
import { useDispatch, useSelector } from "react-redux";
import { selectors as headerSelector, operations as headeroperations } from "../../state/features/header";
import Footer from "./footer";
import helperfunctions from "../../utils/helperfunctions";

const FooterContainer = (props: any) => {
  const [footerLinks, setFooterLinksInfo] = useState([] as ApplicationLink[]);
  const [prefooterLinks, setPreFooterLinksInfo] = useState(
    [] as ApplicationLink[]
  );
  const { headercurrentuser }: any = useSelector((state) => ({
    headercurrentuser: headerSelector.currentuser(state),
  }));
  const userId =
    props?.userId != undefined && props?.userId != "" && props?.userId != ""
      ? props?.userId
      : headercurrentuser?.azureADId;
  let privacypolicy = {} as ApplicationLink;
  let termsofuse = {} as ApplicationLink;
  let fleetManagement = [] as ApplicationLink[];
  let partsPreFooter = [] as ApplicationLink[];
  let othersPreFooter = [] as ApplicationLink[];
    let socialnwPreFooter = [] as ApplicationLink[];
    const dispatch = useDispatch();
    const dispatchAppLinks = headeroperations.dispatchsetAppLinks(dispatch);

  const RetrieveApplicationLinks = () => {
    if (userId != undefined && userId != "") {
      linkServices
        .getLinksForMenus(userId, "Web-Footer,Web-PreFooter")
        .then((response) => {
          if (response != null) {
            let linkResult = response as ApplicationLinkResult;
            localStorage.removeItem("applinks");
            localStorage.setItem("applinks", JSON.stringify(linkResult));
            dispatchAppLinks(linkResult);
            let footerLinksResult = linkResult?.links?.filter(
              (item: { section: string }) =>
                item?.section == LINKSECTION.WebFooter
            );
            let prefooterLinksResult = linkResult?.links?.filter(
              (item: { section: string }) =>
                item?.section == LINKSECTION.WebPreFooter
            );
            setFooterLinksInfo(footerLinksResult);
            setPreFooterLinksInfo(prefooterLinksResult);
          } else {
            GetFromBlobOnfailure();
          }
        })
        .catch((e: any) => {
          GetFromBlobOnfailure();
        });
    }
  };
  const GetFromBlobOnfailure = async () => {
    let userTypestr =
      headercurrentuser?.usertype?.nm != undefined &&
        headercurrentuser?.usertype?.nm != null
        ? headercurrentuser?.usertype?.nm
        : "Customer";
    await linkServices
      .getLinksForBlob(userTypestr, "Applicationlink")
      .then((response) => {
        if (response != null) {
          let linkResult = response as ApplicationLinkResult;
          localStorage.removeItem("applinks");
          localStorage.setItem("applinks", JSON.stringify(linkResult));
          dispatchAppLinks(linkResult);
          let footerLinksResult = linkResult?.links?.filter(
            (item: { section: string }) =>
              item?.section == LINKSECTION.WebFooter
          );
          let prefooterLinksResult = linkResult?.links?.filter(
            (item: { section: string }) =>
              item?.section == LINKSECTION.WebPreFooter
          );
          setFooterLinksInfo(footerLinksResult);
          setPreFooterLinksInfo(prefooterLinksResult);
        }
      });
  };
  if (footerLinks != null && footerLinks.length > 0) {
    privacypolicy = footerLinks?.filter(
      (item: { name: string }) => item?.name == LINKNAME.PrivacyPolicy
    )[0];
    termsofuse = footerLinks?.filter(
      (item: { name: string }) => item?.name == LINKNAME.TermsofUse
    )[0];
  }
  if (prefooterLinks != null && prefooterLinks.length > 0) {
    fleetManagement = prefooterLinks
      ?.filter(
        (item: { name: string }) =>
          item?.name == LINKNAME.PreFooterFleetManagement
      )[0]
      ?.children.sort(
        (a: { displayorder: number }, b: { displayorder: number }) =>
          a.displayorder - b.displayorder
      );
    partsPreFooter = prefooterLinks
      ?.filter(
        (item: { name: string }) => item?.name == LINKNAME.PreFooterParts
      )[0]
      ?.children.sort(
        (a: { displayorder: number }, b: { displayorder: number }) =>
          a.displayorder - b.displayorder
      );
    othersPreFooter = prefooterLinks
      ?.filter(
        (item: { name: string }) => item?.name == LINKNAME.PreFooterOthers
      )[0]
      ?.children.sort(
        (a: { displayorder: number }, b: { displayorder: number }) =>
          a.displayorder - b.displayorder
      );
    socialnwPreFooter = prefooterLinks
      ?.filter(
        (item: { name: string }) =>
          item?.name == LINKNAME.PreFooterSocialNetworks
      )[0]
      ?.children.sort(
        (a: { displayorder: number }, b: { displayorder: number }) =>
          a.displayorder - b.displayorder
      );
  }
  useEffect(() => {
      RetrieveApplicationLinks();
      getfooterDetails();
  }, []);

    const [contactDetails, setContactDetails] = useState<any>([]);
    const [versionDetails, setVersionDetails] = useState<any>([]);
    const getfooterDetails = async () => {
        await fetch("/auth/GetFooterSection")
            .then(async (response) => await response.json())
            .then((json) => {
                setContactDetails(json.contactDetails);
                setVersionDetails(json.versionDetails);
            })
            .catch((error) => {
                setContactDetails([]);
                setVersionDetails([]);
            });
    };

  const userTypeCheck = headercurrentuser.usertype?.name ? headercurrentuser.usertype.name.toLowerCase() : '';
  const roleBasedfilterOptions = helperfunctions.isVisibleBasedOnRole(headercurrentuser.isPLM, headercurrentuser.isVHMS, headercurrentuser.isInternationDbUser, userTypeCheck);

  return (
    <Footer
          fleetManagement={fleetManagement}
          partsPreFooter={partsPreFooter}
          othersPreFooter={othersPreFooter}
          socialnwPreFooter={socialnwPreFooter}
          privacypolicy={privacypolicy}
          termsofuse={termsofuse}
          roleBasedfilterOptions={roleBasedfilterOptions}
          versionDetails={versionDetails}
          contactDetails={contactDetails}
          isGuestUser={headercurrentuser?.isGuestUser}
          headercurrentuser={headercurrentuser}
    />
  );
};
export default FooterContainer;
